import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import "./Navbar.css"

function Navbar() {

    const [show, handelShow] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", (event) => {
            if (window.scrollY > 100) {
                handelShow(true);
            } else handelShow(false);

        });
        return () => {
            window.removeEventListener("scroll" , (event) => {

        }  );
        };
        
    }, []);
  return (
      <div className={`navbar ${show &&`navbar__black`}`}>
          
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1280px-Netflix_2015_logo.svg.png" alt="logo" className="navbar__logo" />

          <img src="https://icon-library.com/images/menu-icon-vector/menu-icon-vector-2.jpg" alt="icon" className="navbar__icon" />
          

      
    </div>
  )
}

export default Navbar;
